import {Component, Input} from '@angular/core';
import {WorkstationConfiguration} from "../../../../../../services/back/workstation-configuration.service";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-workstation-resources',
	imports: [
		CommonModule,
		TranslateModule,
	],
  templateUrl: './workstation-resources.component.html',
  styleUrl: './workstation-resources.component.scss'
})
export class WorkstationResourcesComponent {
	@Input() workstation: WorkstationConfiguration;
}
